<template>
  <div class="user-container" ref="usercontainer">
    <el-row class="user-button">
      <el-button type="primary" @click="dialogAddFormVisible = true"><i class="el-icon-plus"></i>新增栏目</el-button>
    </el-row>

    <el-row class="user-con">
      <template >
        <el-table
            :data="tableData"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            default-expand-all
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column
              prop="id"
              label="id"
              sortable
              >
          </el-table-column>
          <el-table-column
              prop="name"
              label="标题"
              sortable
             >
          </el-table-column>
          <el-table-column
              prop="sort"
              label="排序">
          </el-table-column>

          <el-table-column
              label="操作"
          >
            <template slot-scope="scope">
              <el-row>
                <el-button type="primary" icon="el-icon-edit" circle @click="openUpdate(scope.row.id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" circle @click="openDelete(scope.row.id)"></el-button>
              </el-row>
            </template>

          </el-table-column>
        </el-table>


      </template>
    </el-row>

    <!--    新增部门-->
    <!-- Form -->
    <el-dialog title="新增栏目" :visible.sync="dialogAddFormVisible">
      <el-form :model="addForm" style="text-align: left">
        <el-form-item label="栏目名称" :label-width="formLabelWidth">
          <el-input v-model="addForm.name" autocomplete="off"></el-input>
        </el-form-item>
<!--        <el-form-item label="上级部门" :label-width="formLabelWidth">-->
<!--          <el-select v-model="addForm.pid" placeholder="请选择上级部门">-->
<!--            <el-option label="桓仁红色教育服务中心" value=0></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="addForm.sort" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="上级部门" :label-width="formLabelWidth" style="width:60%">
          <el-select v-model="addForm.parentId" placeholder="请选择上级部门" >
            <el-option label="东北抗日义勇军纪念馆" value="1"></el-option>
            <el-option label="李秋实纪念馆" value="2"></el-option>
            <el-option label="桓仁抗战红都教育服务中心" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit(addForm)">确 定</el-button>
      </div>
    </el-dialog>
    <!-- Form -->

  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "ArticleColumn",
  data(){
    return{
      dialogAddFormVisible:false,
      formLabelWidth: '120px',
      addForm:{
        name:'',
        sort:1,
        parentId:"",
      },
      tableData: [
        {id:1,name:"东北抗日义勇军纪念馆",sort:1,children:[]},
        {id:2,name:"李秋实纪念馆",sort:1,children:[]},
        {id:3,name:"桓仁抗战红都教育服务中心",sort:1,children:[]},
      ],
      child1:{parentId:1},
      child2:{parentId:2},
      child3:{parentId:3},
      restfulUrl:'acolumns',//获取全部列表
    }
  },
  methods:{
    addSubmit:function(data){
      console.log(data)
      data.parentId = parseInt(data.parentId);
      data.sort = parseInt(data.sort);
      request({
        method:'POST',
        url:'/acolumns',
        data:data
      }).then(res =>{
        console.log(res)
        if(res.code == 1){

          this.$message({
            type: 'success',
            message: '新增成功!',
          });
          this.addForm = {
            name:'',
            sort:''
          }
          this.dialogAddFormVisible = false;
          // this.getData();
        }
      },err=>{
        console.log(err)
      })
    },
    getChildData:function(data){//获取全部数据
      request({
        method:'POST',
        url:"/acolumns/allchild",
        data:data,
      }).then(res =>{
        this.tableData[data.parentId-1].children = res.data;

      },err=>{
        console.log(err)
      })
    },
    openUpdate:function(data){
      console.log(data)
    },
    openDelete:function(data){
      console.log(data)
    }
  },
  mounted() {

    this.getChildData(this.child1);
    this.getChildData(this.child2);
    this.getChildData(this.child3);

  }
}
</script>

<style scoped>
.user-button{
  text-align: left;
  padding:0 10px 10px;
  border-bottom: 1px solid rgb(165,165,165);
}
.user-container{
  height:100%;
}
.user-con{
  padding:40px;
}
</style>
